import { render, staticRenderFns } from "./ios.vue?vue&type=template&id=62570c66&scoped=true"
import script from "./ios.vue?vue&type=script&lang=js"
export * from "./ios.vue?vue&type=script&lang=js"
import style0 from "./index.css?vue&type=style&index=0&id=62570c66&prod&lang=css&scoped=true&external"
import style1 from "./ios.vue?vue&type=style&index=1&id=62570c66&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62570c66",
  null
  
)

export default component.exports